// extracted by mini-css-extract-plugin
export var option = "_4w-1";
export var optionActive = "_4w-2";
export var pill = "_4w-0";